import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import store from '@/store';
import VueSimpleAlert from "./plugins/vue-simple-alert";
// import AsyncComputed from 'vue-async-computed';
//import VueLoading from "./plugins/vue-loading";

Vue.config.productionTip = false;

// Vue.use(AsyncComputed)

new Vue({
  vuetify,
  store,
  VueSimpleAlert,
  //VueLoading,
  render: h => h(App)
}).$mount('#app')
